import * as React from "react";
const SvgLogout = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m5-6 5-4-5-4v3H9v2h8z" })));
export default SvgLogout;
//# sourceMappingURL=Logout.js.map